<template>

  <div>
    <!-- 面包屑导航 -->
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>招商部</el-breadcrumb-item>
      <el-breadcrumb-item>人员管理</el-breadcrumb-item>
    </el-breadcrumb> -->

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div  slot="header" class="flexContainer">
        <span  class="cardHeader">人员管理</span>
        <el-button icon="el-icon-plus" style="float:right;" type="primary" size="normal" @click="createClickHandler">添加员工</el-button>
      </div>

      <!-- 搜索条 -->
      <div>
        <el-form :model="queryInfo" :inline="true" size="small">
          <el-form-item label="姓名：">
            <el-input clearable v-model="queryInfo.name" placeholder="请输入姓名" @clear="getList" style="width: 160px"></el-input>
          </el-form-item>
          <el-form-item label="部门：">
            <el-select clearable v-model="queryInfo.department" placeholder="请选择部门" @clear="getList" style="width: 180px" @change="getList">
              <el-option v-for="dept in departmentList" :key="dept._id" :label="dept._id" :value="dept._id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入职时间：">
            <el-date-picker
              v-model="inDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
              style="width: 240px">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="queryInfo.status" placeholder="请选择状态" style="width: 120px" @change="getList">
              <el-option label="在职" :value="1"></el-option>
              <el-option label="离职" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="getList">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <el-table :data="list" style="margin-top:0px">
        <el-table-column label="编号" type="index" width="60px"></el-table-column>
        <el-table-column label="员工信息" width="230px">
          <template slot-scope="scope">
            <div>
              <div style="font-size: 16px; font-weight: bold;">{{ scope.row.name }}</div>
              <div style="font-size: 12px; color: #606266; margin-top: 2px;">
                {{ scope.row.sex }} | {{ scope.row.department }} | {{ scope.row.job }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="微信信息" width="320px">
          <template slot-scope="scope">
            <div v-if="scope.row.bindDxqId" style="display: flex; align-items: center;">
              <img :src="scope.row.dxqAccount.avatar" alt="微信头像" style="width: 40px; height: 40px; border-radius: 50%; margin-right: 10px;">
              <div>
                <div style="font-size: 14px; font-weight: bold;">{{ scope.row.dxqAccount.nickname }}</div>
                <div style="font-size: 11px; color: #909399;">{{ scope.row.dxqAccount.alias }}</div>
              </div>
            </div>
            <div v-else style="font-size: 14px; color: #909399;">未绑定微信</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80px">
          <template slot-scope="scope">
            <el-tag size="small" v-if="scope.row.status === 1" type="success">在职</el-tag>
            <el-tag size="small" v-else type="info">离职</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="入职时间" width="120px">
          <template slot-scope="scope">
            {{ formatDate(scope.row.inDate) }}
          </template>
        </el-table-column>
        <el-table-column label="离职时间" width="120px">
          <template slot-scope="scope">
            {{ scope.row.outDate ? formatDate(scope.row.outDate) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" plain size="small" @click="modifyClickHandler(scope.row)">修改</el-button>
            <el-button type="primary" plain size="small" @click="bindClickHandler(scope.row)" :disabled="scope.row.bindDxqId!==null">绑定招商微信</el-button>
            <el-button type="primary" plain size="small" @click="unbindClickHandler(scope.row)" :disabled="!scope.row.bindDxqId">解绑招商微信</el-button>
            <el-button type="danger" plain size="small" @click="quitClickHandler(scope.row)" :disabled="scope.row.status === 0">离职</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10,20,50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 绑定微信对话框 -->
    <el-dialog
      title="绑定招商微信"
      :visible.sync="bindDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="bind-dialog-content">
        <div class="bind-dialog-header">
          <span>员工信息：</span>
          <span>{{ selectedEmployee?.name }} - {{ selectedEmployee?.department }} - {{ selectedEmployee?.job }}</span>
        </div>
        <div class="wechat-list">
          <el-empty v-if="wechatList.length === 0" description="暂无可用微信账号"></el-empty>
          <div v-for="wechat in wechatList" :key="wechat.id" class="wechat-item">
            <div class="wechat-info">
              <img :src="wechat.avatar" alt="微信头像" class="wechat-avatar" v-if="wechat.avatar">
              <div v-else class="wechat-avatar-placeholder">头像</div>
              <div class="wechat-details">
                <div class="wechat-nickname">{{ wechat.nickname || '未设置昵称' }}</div>
                <div class="wechat-id">ID: {{ wechat.alias }}</div>
              </div>
            </div>
            <el-button type="primary" size="small" @click="confirmBind(wechat)">绑定</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 离职对话框 -->
    <el-dialog
      title="员工离职"
      :visible.sync="quitDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="quit-dialog-content">
        <div class="employee-info">
          <span class="label">员工信息：</span>
          <span class="value">{{ selectedEmployee?.name }} - {{ selectedEmployee?.department }} - {{ selectedEmployee?.job }}</span>
        </div>
        <div class="quit-form">
          <el-form :model="quitForm" :rules="quitFormRules" ref="quitFormRef" label-width="100px">
            <el-form-item label="离职时间" prop="quitDate">
              <el-date-picker
                v-model="quitForm.quitDate"
                type="date"
                placeholder="请选择离职日期"
                value-format="yyyy-MM-dd"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quitDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmQuit">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data () {
    return {
      // 员工列表数据
      list: [],
      // 查询参数
      queryInfo: {
        name: '', // 姓名关键字
        department: '', // 部门ID
        inDateStart: '', // 入职开始时间
        inDateEnd: '', // 入职结束时间
        status: 1, // 员工状态：1-在职，0-离职
        pagenum: 1, // 当前页码
        pagesize: 10 // 每页显示数量
      },
      // 总记录数
      total: 0,
      // 部门列表
      departmentList: [],
      // 入职时间范围选择器绑定值
      inDateRange: null,
      // 绑定微信对话框可见性
      bindDialogVisible: false,
      // 选中的员工
      selectedEmployee: null,
      // 可绑定的微信列表
      wechatList: [],
      // 离职对话框可见性
      quitDialogVisible: false,
      // 离职表单数据
      quitForm: {
        quitDate: '' // 离职日期
      },
      // 离职表单验证规则
      quitFormRules: {
        quitDate: [
          { required: true, message: '请选择离职日期', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    // this.base = window.sessionStorage.getItem('base')
    this.getDepartmentList()
    this.getList()
  },
  methods: {
    // 获取列表
    async getList () {
      const { data: res } = await this.$http.get('zhaoshang/renyuan/list', { params: this.queryInfo })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.list = res.data.list
      this.total = res.data.total
    },

    // 获取部门列表
    async getDepartmentList () {
      const { data: res } = await this.$http.get('zhaoshang/department/list')
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.departmentList = res.data
    },

    // 处理日期范围变化
    handleDateChange (dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.queryInfo.inDateStart = dateRange[0]
        this.queryInfo.inDateEnd = dateRange[1]
      } else {
        this.queryInfo.inDateStart = ''
        this.queryInfo.inDateEnd = ''
      }
      this.getList()
    },

    // 重置查询条件
    resetQuery () {
      this.queryInfo.name = ''
      this.queryInfo.department = ''
      this.queryInfo.inDateStart = ''
      this.queryInfo.inDateEnd = ''
      this.queryInfo.status = 1
      this.inDateRange = null
      this.queryInfo.pagenum = 1
      this.getList()
    },

    // 监听pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getList()
    },

    // 监听页码改变
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getList()
    },

    // 点击添加按钮
    async createClickHandler () {
      this.$router.push('/zhaoshang/renyuan/add')
    },

    // 点击修改按钮
    async modifyClickHandler (row) {
      this.$router.push(`/zhaoshang/renyuan/modify/${row._id}`)
    },

    // 点击删除按钮
    async deleteClickHandler (row) {
      const confirmResult = await this.$confirm(
        '确定要删除吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      const { data: res } = await this.$http.delete(`zhaoshang/renyuan/remove/${row._id}`)

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success(res.meta.msg)
      this.getList()
    },

    // 获取可绑定的微信列表
    async getAvailableWechatList () {
      try {
        const { data: res } = await this.$http.get('zhaoshang/renyuan/getWeixin')
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return []
        }
        return res.data
      } catch (error) {
        this.$message.error('获取微信列表失败')
        console.error('获取微信列表失败:', error)
        return []
      }
    },

    // 点击绑定按钮
    async bindClickHandler (row) {
      this.selectedEmployee = row
      this.wechatList = await this.getAvailableWechatList()
      this.bindDialogVisible = true
    },

    // 确认绑定
    async confirmBind (wechat) {
      try {
        const { data: res } = await this.$http.put('zhaoshang/renyuan/bindWeixin', {
          employeeId: this.selectedEmployee._id,
          weixinId: wechat.id
        })

        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }

        this.$message.success('绑定成功')
        this.bindDialogVisible = false
        this.getList() // 刷新列表以更新绑定状态
      } catch (error) {
        console.error('绑定微信失败:', error)
        this.$message.error('绑定失败，请稍后重试')
      }
    },

    // 点击解绑按钮
    async unbindClickHandler (row) {
      const confirmResult = await this.$confirm(
        '确定要解绑该员工的微信账号吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)

      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      try {
        const { data: res } = await this.$http.put('zhaoshang/renyuan/unbindWeixin', {
          employeeId: row._id
        })

        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }

        this.$message.success('解绑成功')
        this.getList() // 刷新列表以更新绑定状态
      } catch (error) {
        console.error('解绑微信失败:', error)
        this.$message.error('解绑失败，请稍后重试')
      }
    },

    // 点击离职按钮
    async quitClickHandler (row) {
      this.selectedEmployee = row
      // 设置默认离职日期为今天
      this.quitForm.quitDate = this.formatDate(new Date())
      this.quitDialogVisible = true
    },

    // 确认离职
    async confirmQuit () {
      // 表单验证
      this.$refs.quitFormRef.validate(async (valid) => {
        if (!valid) return

        // 二次确认
        const confirmResult = await this.$confirm(
          `确定要将员工 ${this.selectedEmployee.name} 设置为离职状态吗？<br>离职日期：${this.quitForm.quitDate}`,
          '确认离职',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }
        ).catch((err) => err)

        if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

        try {
          // 调用离职接口
          const { data: res } = await this.$http.delete(`zhaoshang/renyuan/remove/${this.selectedEmployee._id}`, {
            data: {
              outDate: this.quitForm.quitDate
            }
          })

          if (res.meta.status !== 200) {
            return this.$message.error(res.meta.msg)
          }

          this.$message.success('员工离职成功')
          this.quitDialogVisible = false
          this.getList() // 刷新列表
        } catch (error) {
          console.error('员工离职失败:', error)
          this.$message.error('离职操作失败，请稍后重试')
        }
      })
    },

    // 格式化日期
    formatDate (date) {
      if (!date) return '-'
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style lang="less" scoped>

/* 绑定微信对话框样式 */
.bind-dialog-content {
  .bind-dialog-header {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;

    span:first-child {
      font-weight: bold;
      margin-right: 10px;
    }
  }

  .wechat-list {
    max-height: 300px;
    overflow-y: auto;
  }

  .wechat-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    margin-bottom: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;

    &:hover {
      background-color: #ecf5ff;
    }
  }

  .wechat-info {
    display: flex;
    align-items: center;
  }

  .wechat-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin-right: 12px;
  }

  .wechat-avatar-placeholder {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #606266;
    margin-right: 12px;
  }

  .wechat-details {
    .wechat-nickname {
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      margin-bottom: 4px;
    }

    .wechat-id {
      font-size: 12px;
      color: #909399;
    }
  }
}

/* 离职对话框样式 */
.quit-dialog-content {
  .employee-info {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;

    .label {
      font-weight: bold;
      margin-right: 10px;
    }

    .value {
      color: #606266;
    }
  }

  .quit-form {
    .el-form-item {
      margin-bottom: 20px;
    }
  }
}
</style>
